let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("834u0")).then(() => parcelRequire('jvoTV'));